import { ReactComponent as PocketFlightsLogo } from "assets/images/pocket-flights-logo.svg";
import { Box, Text } from "components";
import LanguageSwitcher from "components/Reusable/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { getTranslationsStyle } from "utils/arabisation.util";

export default function Header() {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  return (
    <Box d="flex" justifyContent="space-between" alignItems="center" p="m">
      <Box d="flex" gap="s">
        <PocketFlightsLogo
          width={
            theme.logo.pocketFlightsLogoWidth || theme.logo.pocketFlightsWidth
          }
          height={
            theme.logo.pocketFlightsLogoHeight || theme.logo.pocketFlightsHeight
          }
          fill={theme.logo.pocketFlightsLogoFill || theme.colors.primary}
        />
        <LanguageSwitcher />
      </Box>
      <Box>
        <Text
          color="textQuaternary"
          fontWeight="bold"
          style={getTranslationsStyle(i18n)}
        >
          {t("smart_gate.title")}
        </Text>
      </Box>
    </Box>
  );
}
